import React, { Fragment, Key, useEffect, useState } from 'react'
import './Loan.scss'
import { Link, useNavigate } from 'react-router-dom'
import { salaryService } from 'Services/salaryService'
import { CurrencyFormatter, TableSerialNumber } from 'Helpers'
import loanService from 'Services/loanServices'
import { loanType } from 'Models/loanType'
import { Logger } from 'Helpers/Logger'
import { HorizontalLoader, Pagination } from 'Components'
import { TimeConverter } from 'Helpers/TimeConverter'

export interface EmployeeLoanType {
  id: string
  createdAt: string
  userId: string
  amountMajor: number
  purpose: string
  repaymentDurationInMonths: number
  monthlyRepaymentAmountMajor: number
  updatedAt: string
  status: string
  financeApprovalStatus: string
  approvedBy: string
  approvedAt: string
  statusHistory: [
    {
      actor: string
      status: string
      dateTimeInISO8601: string
    },
  ]
  isRepaymentComplete: boolean
}

const Loan = () => {
  const [noLoan, seNoLoan] = useState(true)
  const [loanTaken, setLoanTaken] = useState(false)

  const [pageNumber, setPage] = useState(1)

  const [loan, setLoan] = useState<EmployeeLoanType[]>([])
  const [loading, setLoading] = useState(false)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 0,
  })

  const [loanLimit, setLoanLimit] = useState<number>()
  const [availableLoan, setAvailableLoan] = useState<{
    id: number
    createdAt: string
    updatedAt: string
    userId: string
    repaymentDurationInMonths: number
    monthlyRepaymentAmountMajor: number
    isRepaymentComplete: boolean
    amountMajor: number
    purpose: string
    status: string
    approvedBy: string
    approvedAt: string
  }>()

  const getSalary = async () => {
    await salaryService.getEmployeeSalary().then((response) => {
      // console.log('getSalary response', response.data.data)

      const earning = response.data.data.earnings
      const deduction = response.data.data.deductions

      const totalEarnings = earning.reduce(
        (sum: number, item: { amount: number }) => sum + item.amount,
        0,
      )

      const totalDeductions = deduction.reduce(
        (sum: number, item: { amount: number }) => sum + item.amount,
        0,
      )

      const loanLimit = (totalEarnings - totalDeductions) * 12 * 0.35

      // console.log({
      //   totalEarnings,
      //   totalDeductions,
      //   diff: totalEarnings - totalDeductions,
      //   loanLimit,
      // })

      setLoanLimit(loanLimit)
    })
  }

  const getAllUserLoan = async () => {
    await loanService.getAllUserLoan(1).then((response) => {
      // console.log('getAllUserLoan', response.data.data.dataset)
      // setAvailableLoan(response.data.data.dataset[0])

      seNoLoan(response.data.data.dataset[0] === undefined ? true : false)

      setLoan(response.data.data.dataset)
    })
  }
  const getUserLoan = async () => {
    try {
      const resp = await loanService.getUserLoan()
      const isLoanTaken = resp.data.data.isRepaymentComplete
      if (!isLoanTaken) {
        // console.log('getUserLoan', resp.data.data)
        setAvailableLoan(resp.data.data)

        setLoanTaken(true)
      } else {
        setLoanTaken(false)
      }
    } catch (error: any) {
      console.log('error:', error.response.data.error)
    }
  }

  useEffect(() => {
    getAllUserLoan()
    getUserLoan()
    getSalary()
  }, [])

  const navigate = useNavigate()

  return (
    <div className='Loan me-md-3'>
      <div className='container'>
        <div className='title mt-3'>Employee Loan</div>

        <div className='row mt-4'>
          <div className='col-md-7'>
            <div className='card outstanding px-2 px-md-4'>
              <div className='card-header px-0'>Outstanding Loan Status</div>
              <div className='card-body px-0'>
                <div className='row h-100'>
                  {/* {noLoan === false && availableLoan?.status !== 'PENDING_APPROVAL' && ( */}
                  {loanTaken === true && (
                    <Fragment>
                      <div className='col my-auto'>
                        <div className='amount'>
                          ₦{CurrencyFormatter(availableLoan?.amountMajor ?? 0)}
                        </div>
                      </div>
                      {availableLoan?.isRepaymentComplete == false ? (
                        <div className='col my-auto'>
                          <span className='interest-percentage'>0% Interest</span>
                        </div>
                      ) : (
                        <div className='col my-auto'>
                          <span className='interest-percentage  bg-success text-white'>
                            Completed
                          </span>
                        </div>
                      )}
                    </Fragment>
                  )}

                  {loanTaken === false && (
                    <div className='col-md-12 my-auto no-item text-center'>
                      You do not have an outstanding loan yet
                    </div>
                  )}
                </div>
              </div>
              {loanTaken === true && (
                <div className='card-footer bg-white px-0'>
                  <div className='row'>
                    <div className='col-md-4'>
                      <div className='salary-deduction'>Monthly Salary Deduction</div>
                      <div className='deduction-amount'>
                        ₦ {CurrencyFormatter(availableLoan?.monthlyRepaymentAmountMajor ?? 0)}
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='salary-deduction'>Duration</div>
                      <div className='deduction-amount'>
                        {availableLoan?.repaymentDurationInMonths} Months
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='salary-deduction'>Loan Status</div>
                      <div className='deduction-amount fw-bold'>{availableLoan?.status}</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='col-md-5'>
            <div className='card available-loan px-2 px-md-4'>
              <div className='card-header px-0'>Available Loan Limit</div>
              <div className='card-body px-0 h-100 d-flex justify-content-center align-item-center'>
                <div className='text-center my-auto'>
                  {loanTaken === false ? (
                    <div className='amount'>₦{CurrencyFormatter(loanLimit ?? 0)}</div>
                  ) : (
                    <div className='amount'>₦{CurrencyFormatter(0)}</div>
                  )}

                  {/* {(availableLoan?.isRepaymentComplete === true || noLoan === true) && ( */}
                  <Link to='/loan-application'>
                    <button className='btn btn-default mt-4'>Apply for Loan</button>
                  </Link>
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='card mt-4'>
          <div className='card-header fw-bolder'>Loan History</div>
          <div className='card-body'>
            <div className='table-responsive'>
              <table className='table'>
                <thead>
                  <tr className='fw-bolder'>
                    <td>#</td>
                    <td>Loan Amount</td>
                    <td>Monthly Repayment</td>
                    <td> Repayment Duration</td>
                    <td>Status</td>
                    <td>App. Date</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {loan.length > 0 &&
                    loan.map((data: EmployeeLoanType, index: Key) => (
                      <tr
                        key={index}
                        onClick={() => {
                          navigate(`/loan/details/${data.id}`)
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <td>
                          {TableSerialNumber(
                            pageNumber,
                            paginationData.pageSize,
                            parseInt(index.toString()),
                          )}
                        </td>
                        <td>₦{CurrencyFormatter(data.amountMajor)}</td>
                        <td>₦{CurrencyFormatter(Number(data.monthlyRepaymentAmountMajor))}</td>

                        <td>{data.repaymentDurationInMonths ?? 0} Months</td>

                        <td
                          className={
                            data.status === 'REJECTED'
                              ? 'text-danger fw-bold'
                              : data.status === 'COMPLETED_REPAYMENT'
                                ? 'text-success fw-bold'
                                : data.status === 'APPROVED'
                                  ? 'text-success fw-bold'
                                  : data.status === 'PENDING_APPROVAL'
                                    ? 'text-orange fw-bold'
                                    : 'text-success fw-bold'
                          }
                        >
                          {data.status === 'REJECTED'
                            ? 'Rejected'
                            : data.status === 'COMPLETED_REPAYMENT'
                              ? 'Completed Repayment'
                              : data.status === 'APPROVED'
                                ? 'Approved'
                                : data.status === 'PENDING_APPROVAL'
                                  ? 'Pending Approval'
                                  : data.status}
                        </td>
                        <td>{TimeConverter(data.createdAt)}</td>

                        <td>
                          <Link to={`/loan/details/${data.id}`}>
                            <button
                              className='btn btn-default border-0'
                              data-bs-toggle='dropdown'
                              aria-expanded='false'
                              data-bs-popper-config='{"strategy":"fixed"}'
                            >
                              View Details
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))}

                  {loading === false && loan.length === 0 && (
                    <tr>
                      <td colSpan={8} className='text-center'>
                        No loan found
                      </td>
                    </tr>
                  )}
                  {loading === true && loan.length === 0 && (
                    <tr>
                      <td colSpan={8} className='text-center'>
                        <HorizontalLoader></HorizontalLoader>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {paginationData.total >= paginationData.pageSize && (
              <div className='pagination w-100 d-flex justify-content-center'>
                {paginationData.total && (
                  <Pagination
                    className='pagination-bar ps-0'
                    currentPage={Number(paginationData.pageNumber)}
                    totalCount={paginationData.total}
                    pageSize={paginationData.pageSize}
                    onPageChange={(page: React.SetStateAction<number>) => setPage(page)}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Loan
